import { Fragment } from 'react';

export interface SidebarFooterLink {
  label: string;
  href: string;
}

export interface SidebarFooterLinksProps {
  links: SidebarFooterLink[];
  separatorLabel: string;
  isOpen: boolean;
}

const stylesheet = {
  container:
    'h-fit whitespace-nowrap flex flex-row justify-center items-center text-semantic-text-secondary gap-2 mt-4',
  itemsWrapper: 'flex items-center justify-center',
  items:
    'w-fit transition-all duration-500 hover:underline text-center text-xs text-semantic-text-secondary',
  separator: 'text-semantic-text-secondary text-[6px] select-none',
};

export function SidebarFooterLinks({
  links,
  separatorLabel,
  isOpen,
}: Readonly<SidebarFooterLinksProps>) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={stylesheet.container}>
      {links.map((link, index) => (
        <Fragment key={link.href}>
          {index > 0 && (
            <div className={stylesheet.itemsWrapper}>
              <span className={stylesheet.separator}>{separatorLabel}</span>
            </div>
          )}
          <div className={stylesheet.itemsWrapper}>
            <a
              className={stylesheet.items}
              target="_blank"
              href={link.href}
              rel="noreferrer"
            >
              {link.label}
            </a>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
